import './Stepper.scss';

import React from 'react';

type Props = {
  total: number;
  current: number; // 0-based index
  className?: string;
  // number of additional past steps to render on the left
  startFrom?: number;
};

export const Stepper: React.FC<Props> = ({ total, current, className, startFrom = 0 }) => {
  if (!total || total <= 1) return null;
  const leftPad = Math.max(0, startFrom);
  const length = total + leftPad;
  const currentIndex = Math.min(length - 1, Math.max(0, leftPad + current));
  return (
    <div className={`po-stepper ${className || ''}`.trim()} aria-hidden='true'>
      {Array.from({ length }).map((_, i) => {
        const state = i === currentIndex ? 'current' : i < currentIndex ? 'past' : 'future';
        return <div key={i} className={`po-stepper__line po-stepper__line--${state}`} />;
      })}
    </div>
  );
};

export default Stepper;
